import Cookies from 'cookies-js';

window.addEventListener('DOMContentLoaded', () => {
    const COOKIE_NAME = 'COOKIES_ACCEPTED';
    const ACTIVE_CLASS = 'cookie-banner--visible';

    if (Cookies.get(COOKIE_NAME) === 'true') return;

    const banner = document.querySelector('.cookie-banner');
    if (!banner) return;

    const acceptBtn = banner.querySelector('.js-cookie-consent-accept');
    const consentLabel = banner.querySelector('[data-bx-user-consent]');

    setTimeout(() => banner.classList.add(ACTIVE_CLASS), 1000);

    acceptBtn.addEventListener('click', () => {
        if (consentLabel) consentLabel.click();

        Cookies.set(COOKIE_NAME, 'true', { expires: Infinity });
        banner.classList.remove(ACTIVE_CLASS);
        setTimeout(() => banner.remove(), 1000);

        document.querySelectorAll('script[data-defer-metrics]').forEach(original => {
            const script = document.createElement('script');
            const src = original.getAttribute('data-src');
            if (src) {
                script.src = src;
                script.async = true;
            } else {
                script.textContent = original.textContent;
            }
            document.head.appendChild(script);
            original.remove();
        });
    });
});
